import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiNotificationFull, ApiNotificationsFilter } from "@/types/notification.types.ts";

export const apiNotifications = {
  searchNotifications: (filter: ApiNotificationsFilter, signal: AbortSignal) => {
    return api.post<ApiPagedData<ApiNotificationFull>>(
      `/api/v1/notifications/search`,
      filter,
      signal
    );
  },
  markAsRead: (id: number, archive?: boolean) => {
    return api.post(`/api/v1/notifications/${id}/read`, { archive });
  },
};
